<template>
<tr>
    <th class="sheet-header text-truncate text-capitalize font-weight-regular" style="border-left: 2px solid white">
        <v-tooltip bottom>
            <template v-slot:activator="{ on }">
                <v-icon color="orange" size="14" v-on="on" style="vertical-align: text-bottom">info_outline</v-icon>
            </template>
            <span>
                <div class style="width: max-content">
                    <span class="pl-1">Puteti modifica doar din modalul Preturi(Update in masa)</span>
                </div>
            </span>
        </v-tooltip>
        Max Booking date
    </th>
    <td class="sheet-cell text-center" v-for="(day, index) in prices" :key="index">
        <input v-model.lazy="day.max_booking_date" placeholder="aaaa-ll-zz" class="sheet-input" @change="save(day)" />
    </td>
</tr>
</template>
<script>
export default {
    props: {
        prices: Object
    },
}
</script>
